import { makeAdSupportedGamePolicy } from './game-ads'

/**
 * Snowback — 되감기가 발판이 되는 겨울 퍼즐. 무료 + AdMob 광고 + 광고 제거 인앱결제.
 *
 * 처음부터 광고 골격으로 세웠다 — 수집 0 오프라인 골격(game-offline.ts)을 잠깐이라도
 * 고르면 광고를 붙이는 날 한 문서 안에서 앞뒤가 어긋난다 (privacy-policy.md §새 서비스).
 */
export const SNOWBACK_POLICY = makeAdSupportedGamePolicy({
  slug: 'snowback',
  title: 'Snowback Privacy Policy',
  name: 'Snowback',
  storedOnDevice:
    'Which levels you have cleared, how many planks you had left over on each, how many levels you have finished in total, whether you bought the ad removal, and your sound and music volume are the only things the app keeps.',
  removeAdsProductId: 'com.cottonray.snowback.remove_ads',
  effectiveDate: 'August 25, 2026',
  history: [
    'August 25, 2026 — established (structured on Article 30 of the Personal Information Protection Act, including notice of transfers abroad), covering advertising through Google AdMob (a banner in a reserved strip along the bottom while you play and one interstitial when a game ends) and the one-off in-app purchase that removes them. The game requests network access for those two things only',
  ],
})
